// Icon primitives — 16×16 stroke-only monoline SVG set.
// This is the canonical icon library for the rebuild. Do NOT import
// Heroicons / Lucide / MUI icons in new components.
//
// Two access patterns supported:
//   - Import individually:   import { Dash, Search } from './Icons';
//   - Index by string key:   Icons[item.icon]  // for dynamic nav config
// The second pattern is why a lowercase-keyed object exists alongside the
// PascalCase exports.

import React from 'react';

const Svg = ({ size = 16, children, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    {children}
  </svg>
);

export const Dash    = (p) => <Svg {...p}><path d="M2 3h5v5H2zM9 3h5v9H9zM2 10h5v3H2z"/></Svg>;
export const Msg     = (p) => <Svg {...p}><path d="M2.5 4h11v7h-6l-3 2.5V11h-2z"/></Svg>;
export const Mail    = (p) => <Svg {...p}><rect x="2.5" y="4" width="11" height="8" rx="0.5"/><path d="M2.5 4.5L8 8.5l5.5-4"/></Svg>;
export const Report  = (p) => <Svg {...p}><path d="M3 13V7M6.5 13V4M10 13V9M13.5 13V6"/></Svg>;
export const Vcp     = (p) => <Svg {...p}><path d="M8 2.5l5.5 3v5L8 13.5 2.5 10.5v-5z"/><path d="M8 8.5v5M2.5 5.5L8 8.5l5.5-3"/></Svg>;
export const Cust    = (p) => <Svg {...p}><circle cx="8" cy="6" r="2.5"/><path d="M3 13.5c.5-2.5 2.5-4 5-4s4.5 1.5 5 4"/></Svg>;
export const Visit   = (p) => <Svg {...p}><path d="M8 1.5C5.5 1.5 3.5 3.5 3.5 6c0 3.5 4.5 8 4.5 8s4.5-4.5 4.5-8c0-2.5-2-4.5-4.5-4.5z"/><circle cx="8" cy="6" r="1.5"/></Svg>;
export const Cal     = (p) => <Svg {...p}><rect x="2.5" y="3.5" width="11" height="10" rx="0.5"/><path d="M2.5 6.5h11M5 2v3M11 2v3"/></Svg>;
export const Tma     = (p) => <Svg {...p}><circle cx="8" cy="8" r="5.5"/><path d="M8 5v3l2 1.5"/></Svg>;
export const Fleet   = (p) => <Svg {...p}><path d="M2 10h12M3 10V7l1.5-3h7L13 7v3M3 10v2h2v-2M11 10v2h2v-2"/><circle cx="5" cy="10" r=".5"/><circle cx="11" cy="10" r=".5"/></Svg>;
export const Wrench  = (p) => <Svg {...p}><path d="M10.5 2.5a3 3 0 013 3l-1.5 1.5-2-2L11.5 3.5a3 3 0 01-1-1zM10 5.5L3.5 12 2 13.5 3.5 13 5 12l.5-1.5L12 4"/></Svg>;
export const Cog     = (p) => <Svg {...p}><circle cx="8" cy="8" r="2"/><path d="M8 1.5v2M8 12.5v2M1.5 8h2M12.5 8h2M3.3 3.3l1.4 1.4M11.3 11.3l1.4 1.4M3.3 12.7l1.4-1.4M11.3 4.7l1.4-1.4"/></Svg>;
export const Users   = (p) => <Svg {...p}><circle cx="6" cy="6" r="2"/><circle cx="11.5" cy="6.5" r="1.5"/><path d="M2 13c.4-2 2-3 4-3s3.6 1 4 3M10 13c.3-1.5 1-2.2 2-2.2s1.7.7 2 2.2"/></Svg>;
export const Search  = (p) => <Svg {...p}><circle cx="7" cy="7" r="4.5"/><path d="M10.5 10.5L14 14"/></Svg>;
export const Chev    = (p) => <Svg {...p}><path d="M6 3l4 5-4 5"/></Svg>;
export const ChevD   = (p) => <Svg {...p}><path d="M3 6l5 4 5-4"/></Svg>;
export const Up      = (p) => <Svg {...p}><path d="M3 11l5-5 5 5"/></Svg>;
export const Down    = (p) => <Svg {...p}><path d="M3 5l5 5 5-5"/></Svg>;
export const Plus    = (p) => <Svg {...p}><path d="M8 3v10M3 8h10"/></Svg>;
export const Close   = (p) => <Svg {...p}><path d="M3.5 3.5l9 9M12.5 3.5l-9 9"/></Svg>;
export const Check   = (p) => <Svg {...p}><path d="M3 8.5l3 3 7-7"/></Svg>;
export const Dots    = (p) => <Svg {...p}><circle cx="3.5" cy="8" r=".8"/><circle cx="8" cy="8" r=".8"/><circle cx="12.5" cy="8" r=".8"/></Svg>;
export const Phone   = (p) => <Svg {...p}><path d="M3 3.5c0 5 4.5 9.5 9.5 9.5L13 11l-2.5-1.5L9 11C7 10 6 9 5 7l1.5-1.5L5 3z"/></Svg>;
export const Oil     = (p) => <Svg {...p}><path d="M8 2.5L5 6v6.5c0 .6.4 1 1 1h4c.6 0 1-.4 1-1V6z"/><path d="M8 2.5l-1-1h2z"/></Svg>;
export const Clock   = (p) => <Svg {...p}><circle cx="8" cy="8" r="5.5"/><path d="M8 5v3l2 1.5"/></Svg>;
export const Filter  = (p) => <Svg {...p}><path d="M2.5 3.5h11L9.5 8v4L6.5 13V8z"/></Svg>;
export const Upload  = (p) => <Svg {...p}><path d="M8 10.5V2.5M5 5.5l3-3 3 3M2.5 10v3.5h11V10"/></Svg>;
export const Slider  = (p) => <Svg {...p}><path d="M3 5h10M3 8h10M3 11h10"/><circle cx="6" cy="5" r="1.2" fill="currentColor"/><circle cx="10" cy="8" r="1.2" fill="currentColor"/><circle cx="5" cy="11" r="1.2" fill="currentColor"/></Svg>;
export const Flag    = (p) => <Svg {...p}><path d="M3.5 13.5V2.5M3.5 3h7l-1.5 2.5L10.5 8h-7"/></Svg>;
export const Pin     = (p) => <Svg {...p}><path d="M8 1.5a4 4 0 00-4 4c0 3 4 8 4 8s4-5 4-8a4 4 0 00-4-4z"/><circle cx="8" cy="5.5" r="1.3"/></Svg>;
export const Logout  = (p) => <Svg {...p}><path d="M9 3.5H3.5v9H9M11 5.5L13.5 8L11 10.5M6 8h7.5"/></Svg>;

// Index for dynamic lookup, e.g. Icons[navItem.icon]. Keys match the strings
// used in navConfig.js.
export const Icons = {
  dash: Dash, msg: Msg, report: Report, vcp: Vcp, cust: Cust, visit: Visit,
  cal: Cal, tma: Tma, fleet: Fleet, wrench: Wrench, cog: Cog, users: Users,
  search: Search, chev: Chev, chevD: ChevD, up: Up, down: Down, plus: Plus,
  close: Close, check: Check, dots: Dots, phone: Phone, oil: Oil, clock: Clock,
  filter: Filter, upload: Upload, slider: Slider, flag: Flag, pin: Pin, logout: Logout,
};

export default Icons;
